export default { sha: 'b2afa7d9f18ff7ba2b527ae772106fa4b09a8fca', buildNumber: 'undefined' }
